<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col v-if="workingPicks.length <= 0" cols="12" sm="12">
          <v-card class="elevation-0">
            <v-alert
              height="60vh"
              class="d-flex justify-center"
              elevation="0"
            >Keine Picks in Bearbeitung.</v-alert>
          </v-card>
        </v-col>
        <v-col v-for="(workingPick, indx) in workingPicks" :key="indx" cols="12" md="6" sm="12">
          <v-card class="elevation-3" tile>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="headline">{{workingPick.pixi_id}}</v-list-item-title>
                <v-list-item-subtitle>Erstellt von {{workingPick.created_from}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list>
              <v-list-item>
                <v-icon>mdi-account</v-icon>
                <v-list-item-title class="ml-3">Picker:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{workingPick.in_progress_by}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-icon>mdi-package-variant</v-icon>
                <v-list-item-title class="ml-3">Box:</v-list-item-title>
                <v-list-item-subtitle
                  class="text-right"
                >{{workingPick.box_from}}-{{workingPick.box_to}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-icon>mdi-calendar-clock</v-icon>
                <v-list-item-title class="ml-3">Erstellt am:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{formatDate(workingPick.created_at)}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-icon>mdi-calendar-clock</v-icon>
                <v-list-item-title class="ml-3">Ablaufdatum:</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{formatDate(workingPick.expires_at)}}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
            <v-divider />
            <v-card-actions>
              <v-btn @click.stop="resetPicklist(workingPick.id)" text color="#323232">Zurücksetzen</v-btn>
              <v-spacer />
              <v-btn
                @click.stop="selectInProgressPick(workingPick.in_progress_by, workingPick.id, workingPick.pixi_id)"
                text
                color="#ff9117"
              >Übernehmen</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog.open" max-width="400">
      <v-card>
        <v-card-title>{{dialog.title}}</v-card-title>
        <v-card-text>{{dialog.text}}</v-card-text>
        <v-card-actions>
          <v-btn color="#323232" text @click="dialog.open = false">Abbrechen</v-btn>
          <v-spacer />
          <v-btn color="#faa619" text @click="dialog.action()">Zustimmen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar bottom v-model="snackbar" :color="snackbarColor">
      {{ selectedPickStatusText }}
      <v-btn color="white" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import picklistService from "../services/picklistService";
import { mapState } from "vuex";
import datetimeFormatter from "../helpers/datetimeFormatter";

export default {
  name: "InProgressPicksList",
  data() {
    return {
      dialog: {
        open: false,
        title: "",
        text: ""
      },
      selectedPickId: null,
      snackbar: false,
      snackbarColor: "white",
      selectedPickStatusText: "",
      selectedProgressPick: {
        id: "",
        pixiId: "",
      }
    };
  },
  computed: mapState({
    workingPicks: state => state.picklists.workingPicklist
  }),
  methods: {

      takeover() {
        this.dialog.open = false;
        this.snackbar = true;
        this.selectedPickStatusText = "Erfolgreich übernommen";
        this.snackbarColor = "#faa619";
        
        const that = this;
        picklistService.takeOver(this.selectedProgressPick.id)
          .then(() => picklistService.picklistDetails(this.selectedProgressPick.id))
            .then(pickDetail => {
                console.log(pickDetail);
                console.log(JSON.stringify(pickDetail));
                that.$store.dispatch("setCurrentPick", {
                  items: [...pickDetail.items],
                  open: [...pickDetail.items],
                  done: [],
                  pick: pickDetail.items[0],
                  id: that.selectedProgressPick.id,
                  pixi_id: that.selectedProgressPick.pixiId,
                });
                setTimeout(() => {
                    that.$router.push("/pick");
                }, 500);
            });
      },

      resetPicklist(id) {
        picklistService.resetPicklist(id)
          .then(() => picklistService.picklist())
          .then(() => {
            this.$store.dispatch("resetCurrentPick");
          });
      },

      selectInProgressPick(username, id, pixiId) {
        this.dialog.open = true;
        this.dialog.title = `Den Pick ${pixiId} von ${username} übernehmen?`;
        this.dialog.text =
            "Drücken Sie auf Zustimmen um den Pick zu übernehmen.";
        this.dialog.action = this.takeover;

        this.selectedProgressPick.id = id;
        this.selectedProgressPick.pixiId = pixiId;
        this.selectedPickId = id;
      },

      formatDate(value) {
        return datetimeFormatter.formatIntoDateTime(value);
      }
  }
};
</script>